// extracted by mini-css-extract-plugin
export default {"heart":"HeartIcon_heart__Pr3yo","requestedStylist":"HeartIcon_requestedStylist__+3TVI","dark":"HeartIcon_dark__Wyr0B"};